import { io, Socket } from 'socket.io-client';
import CONFIG from './config';

const socket: Socket = io(CONFIG.SOCKET_URL, {
  autoConnect: false,
});

export default socket;
